import PropTypes from "prop-types";
import { usePermission } from "../../context/PermissionContext";
import Unauthorized from "./Unauthorized";

/* Route-level guard: renders children only if the logged-in admin has ANY
   permission at all on `module` (per the get-user roles payload) — not
   specifically the `action` passed in. A submodule can be granted access
   via a single non-"View" action (e.g. Notification with only "Edit"), and
   the role should still be able to open that page; requiring an exact
   action match here would block a route the sidebar itself shows as
   accessible. Fine-grained action gating (show/hide an Edit button, etc.)
   happens separately, inside each page, via isAllowed()/PermissionGate.

   Renders an in-place "unauthorized" message instead of navigating away —
   redirecting (e.g. to "/") risks a loop, since "/" and other fallback
   routes redirect through further guarded routes (RTO_SERVICES index ->
   RTO_CASES, etc.) which may themselves be denied, bouncing back and forth
   forever ("Maximum update depth exceeded"). */
const PermissionRoute = ({ module, children }) => {
  const { hasModuleAccess } = usePermission();

  if (hasModuleAccess(module)) {
    return children;
  }

  return <Unauthorized />;
};

PermissionRoute.propTypes = {
  module: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
};

export default PermissionRoute;
